module.exports = __webpack_public_path__ + "static/media/lab.7bc4ff1e.svg";